/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { OfferWorkflowDto } from '../models';
/**
 * RestOfferWorkflowApi - axios parameter creator
 */
export const RestOfferWorkflowApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current offer workflow catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferWorkflow: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/offer-workflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestOfferWorkflowApi - functional programming interface
 */
export const RestOfferWorkflowApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestOfferWorkflowApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current offer workflow catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOfferWorkflow(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferWorkflowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOfferWorkflow(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestOfferWorkflowApi.getOfferWorkflow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestOfferWorkflowApi - factory interface
 */
export const RestOfferWorkflowApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestOfferWorkflowApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current offer workflow catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferWorkflow(options?: RawAxiosRequestConfig): AxiosPromise<OfferWorkflowDto> {
            return localVarFp.getOfferWorkflow(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestOfferWorkflowApi - interface
 */
export interface RestOfferWorkflowApiInterface {
    /**
     * 
     * @summary Get current offer workflow catalog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOfferWorkflow(options?: RawAxiosRequestConfig): AxiosPromise<OfferWorkflowDto>;

}

/**
 * RestOfferWorkflowApi - object-oriented interface
 */
export class RestOfferWorkflowApi extends BaseAPI implements RestOfferWorkflowApiInterface {
    /**
     * 
     * @summary Get current offer workflow catalog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOfferWorkflow(options?: RawAxiosRequestConfig) {
        return RestOfferWorkflowApiFp(this.configuration).getOfferWorkflow(options).then((request) => request(this.axios, this.basePath));
    }
}

